module.exports = __webpack_public_path__ + "static/derave-video-1d0cb3a2199ae195183ecc48aa36f93e.mp4";